import { list } from 'src/app/common/classes/request-builder';
import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';

import { ClienteModel } from 'src/app/models/cliente.model';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { Uso } from 'src/app/models/productos/uso.model';

export class TratamientosListsDefinition {

    public clientes: TypeAheadInterface<ClienteModel> = list(['...', null]);

    public productos: TypeAheadInterface<ProductosModel> = list(['...', null]);

    /**
     * Optional full product catalog.
     * Useful when one environment shows all products and another applies filters.
     */
    public productosAll: TypeAheadInterface<ProductosModel> = list(['...', null]);

    /**
     * Dynamic row-level dropdown sources.
     * They are kept here for consistency with the rest of reactive forms.
     */
    public usosPlaceholder: TypeAheadInterface<Uso> = list(['...', null]);

    public agentesPlaceholder: TypeAheadInterface<Uso> = list(['...', null]);

    public unidadesMedida: TypeAheadInterface<string> = list(
        ['...', null],
        'kg/ha',
        'L/ha',
        'kg',
        'L'
    );
}